//
// MapSearchHint.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";

var MapSearchHint = createModule("commons::MapSearchHint", [], EventDispatcher, [
    ,
    ,
    ,
    {
        hint: 7,
        isCollection: 2,
        key: 7,
    },
    ,
    {
        _create: [4],
    },
    ,
]);
export default MapSearchHint;
